module.exports = __webpack_public_path__ + "static/media/icon_sort_up.be9076af.svg";